import * as api from '../api';

// set token in redux store
export const SET_TOKEN = 'SET_TOKEN';
export const setToken = token => {
  return {
    type: SET_TOKEN,
    token
  };
};

export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const clearToken = () => {
  return {
    type: CLEAR_TOKEN
  }
};

export const GET_TOKEN = 'GET_TOKEN';
// redux thunk wraps actions to provide dispatch
export const getToken = (username, password) => (dispatch) =>
  api.getToken(username, password)
    .then(token => {
      dispatch(setToken(token));
      return token;
    });



// WEBPACK FOOTER //
// ./src/actions/token.js